import React from 'react';

import {
  Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import {
  signUpConfirm,
  resendSignUp,
} from '../thunk';

import type {
  UserType,
} from '@/types/domain/user/redux';

import TextFieldComp from '@/components/TextFieldComp';
import {
  userSlice,
} from '@/domain/user/redux';

/**
 * プロパティ
 */
export type Props = {
  /** ユーザー */
  user: UserType;
}

const SignUpConfirm: React.FC<Props> = ({ user }) => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<{
    username: string;
    code: string;
  }>({
    defaultValues: {
      code: '',
      username: '',
    },
  });
  const title = `新規登録: ユーザーID「${user.name}」`;
  const onSubmit = (input: {
    username: string;
    code: string;
  }) => {
    dispatch(signUpConfirm({
      ...input,
      username: user.name,
    }));
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2 style={{ textAlign: 'center' }}>
        {title}
      </h2>
      <TextFieldComp
        type="text"
        control={control}
        rules={{
          required: '必須項目です',
        }}
        name="code"
        label="認証コード"
        placeholder=""
        errors={errors}
      />
      <div style={{ textAlign: 'center', fontSize: '0.8em' }}>
        メールアドレスに送られた認証コードを入力して認証ボタンを押してください。
      </div>
      <div style={{ textAlign: 'center', margin: '10px 0' }}>
        <Button
          size="large"
          type="submit"
          variant="contained"
          color="primary"
        >
          認証
        </Button>
      </div>
      <div style={{ textAlign: 'center' }}>
        <Button size="small" onClick={() => dispatch(resendSignUp(user.name))}>
          認証コードを再送する
        </Button>
      </div>
      <div style={{ textAlign: 'center' }}>
        <Button size="small" onClick={() => dispatch(userSlice.actions.setMode('signin'))}>
          ログインはこちら
        </Button>
      </div>
    </form>
  );
};

export default SignUpConfirm;
